import api from '../../../App/socket';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const searchBikeModel = async (value, ref_bike_brand) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_MODELS}?filterByName=${value}&brandId=${ref_bike_brand}&includeBikeBrand=true&limit=25`,
        });
        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};

export const countBikeModels = (value, ref_bike_brand) => (
    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Count',
        options: {
            where: {
                ref_bike_brand,
                $or: [
                    {
                        name: {
                            $regex: value,
                            $options: 'i',
                        },
                    },
                    {
                        alternative_name: {
                            $regex: value,
                            $options: 'i',
                        },
                    }],
                // {
                //   ref_bike_brand
                // }]
            },
        },
    }).then((response) => response).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/search_bike_model_request.js